// @flow

const _ = require('lodash');


function Memento (options) {
	options = _.defaults({}, options, {
		save: function () {
			return null;
		},
		// eslint-disable-next-line no-unused-vars
		restore: function (state) { /* smth = state; */ },
	});

	this._options = options;

	this._store = {};
}

function withNameDefault (method) {
	return function (name, ...rest) {
		name = name || this.DEFAULT_NAME;
		return method.call(this, name, ...rest);
	};
}

Memento.prototype = {
	DEFAULT_NAME: '_default_',
	_withNameDefault: withNameDefault,
	clear: withNameDefault(function (name) {
		delete this._store[name];
	}),
	clearAll: function () {
		this._store = {};
	},
	isEmpty: withNameDefault(function (name) {
		return _.isUndefined(this._store[name]);
	}),
	_peek: function (name) {
		return this._store[name];
	},
	peek: withNameDefault(function (name) {
		return this._peek(name);
	}),
	_save: function (name, data) {
		this._store[name] = data;
	},
	save: withNameDefault(function (name, data) {
		if (_.isUndefined(data)) {
			data = this._options.save();
		}
		this._save(name, data);
	}),
	restore: withNameDefault(function (name) {
		const state = this.peek(name);
		this._options.restore(state);
		return state;
	}),
};

export type MementoOptions = {
	save: () => Object,
	restore: (?Object) => void,
};

export interface MementoInterface {
	constructor(MementoOptions): void;

	DEFAULT_NAME: string;

	clear(): void;
	clear(name: string): void;

	clearAll(): void;

	isEmpty(): boolean;
	isEmpty(name: string): boolean;

	peek(): ?Object;
	peek(name: string): ?Object;

	save(data: ?Object): void;
	save(name: string, data: ?Object): void;

	restore(): void;
	restore(name: string): void;

	_peek(name: string): ?Object;
	_save(name: string, data: ?Object): void;
}

module.exports = ((Memento: any): Class<MementoInterface>);
